export default function Hero() {
  return (
    <section className="relative w-full h-[380px] md:h-[480px] flex items-end pb-12 md:pb-16" id="home">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://www.advancedasphaltca.com/wp-content/uploads/2025/06/banner-image.png"
          alt="NJ Commercial Asphalt Paving"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-black/55"></div>
      </div>

      {/* Title */}
      <div className="relative w-full max-w-7xl mx-auto px-6">
        <h1
          className="text-white text-4xl md:text-6xl font-extrabold uppercase leading-tight"
          style={{ fontFamily: "'Oswald', sans-serif" }}
        >
          NEW JERSEY
        </h1>
      </div>
    </section>
  );
}
